export default "__VITE_ASSET__77347840__"